var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "distribute-detail" },
    [
      _vm.$route.meta
        ? _c("div", { staticClass: "header" }, [
            _vm._v(_vm._s(_vm.$route.meta.title)),
          ])
        : _vm._e(),
      _c("Detail", {
        ref: "getTable",
        attrs: {
          tableData: _vm.tableForm,
          tableFormAttrs: _vm.tableFormAttrs,
          filterDataRules: _vm.filterDataRules,
          formLabelWidth: "95px",
        },
        on: {
          submitForm: _vm.submitForm,
          handleAvatarSuccess: _vm.handleAvatarSuccess,
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (button) {
              return [
                _vm.isEdit
                  ? [
                      _c("el-button", { on: { click: _vm.cancel } }, [
                        _vm._v("取消"),
                      ]),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.submitForm()
                            },
                          },
                        },
                        [_vm._v("保存")]
                      ),
                    ]
                  : [
                      _vm.type !== 2
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.edit()
                                },
                              },
                            },
                            [_vm._v("编辑")]
                          )
                        : _vm._e(),
                    ],
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }